"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AREA = {
    /**
     * 根据locationCode判断是否属于大陆、港澳台、海外
     * @param	{String}	locationCode	城市Code
     * @returns	{String}	香港-HK，澳门-MO, 台湾-TW，IBU-国际，CHN-大陆
     */
    areaJudge: function (locationCode) {
        if (locationCode === void 0) { locationCode = ''; }
        return ((locationCode === '852' && 'HK') ||
            (locationCode === '853' && 'MO') ||
            (locationCode === '886' && 'TW') ||
            (/^[A-Z]{2,20}$/.test(locationCode) && 'IBU') ||
            'CHN');
    },
    // 港澳台-HKMOTW，IBU-国际，CHN-大陆
    areaInHKMOTWIBUCHN: function (locationCode) {
        if (locationCode === void 0) { locationCode = ''; }
        return (['852', '853', '886'].some(function (item) { return item === locationCode; }) && 'HKMOTW') || (/^[A-Z]{2,20}$/.test(locationCode) && 'IBU') || 'CHN';
    },
    // 大陆地区
    isCHN: function (locationCode) {
        if (locationCode === void 0) { locationCode = ''; }
        return this.areaJudge(locationCode) === 'CHN';
    },
    // 港澳台地区
    isHKMOTW: function (locationCode) {
        if (locationCode === void 0) { locationCode = ''; }
        return this.areaInHKMOTWIBUCHN(locationCode) === 'HKMOTW';
    },
    // 国际地区
    isIBU: function (locationCode) {
        if (locationCode === void 0) { locationCode = ''; }
        return this.areaJudge(locationCode) === 'IBU';
    },
    // 香港地区
    isHK: function (locationCode) {
        if (locationCode === void 0) { locationCode = ''; }
        return locationCode === '852';
    },
    // 澳门地区
    isMO: function (locationCode) {
        if (locationCode === void 0) { locationCode = ''; }
        return locationCode === '853';
    },
    // 台湾地区
    isTW: function (locationCode) {
        if (locationCode === void 0) { locationCode = ''; }
        return locationCode === '886';
    },
    /**
     * 运单流向
     * @param from 寄件人locationCode
     * @param to 收件人locationCode
     * @param elaborate 是否返回详细流向，true => CHN_HK， false => CHN_HKMOTW
     * @returns	CHN_CHN-大陆-大陆，大陆-港澳台，HK_MO-香港-澳门，
     */
    flow: function (from, to, elaborate) {
        if (from === void 0) { from = ''; }
        if (to === void 0) { to = ''; }
        if (elaborate === void 0) { elaborate = false; }
        var fromInArea = this.areaJudge(from);
        var toInArea = (elaborate && this.areaJudge(to)) || this.areaInHKMOTWIBUCHN(to);
        return fromInArea + '_' + toInArea;
    }
};
exports.default = {
    name: 'utils-check-area',
    install: function (UIP) {
        UIP.checkModule('utils', 'check', 'AREA');
        UIP.utils.check.AREA = AREA;
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/utils-check-area/dist/index.js
// module id = NrAC
// module chunks = 1